export default __webpack_public_path__ + "static/media/SS3Medium.otf.2c235c4d.woff2";